var map = {
	"./emoji-agenda.svg": 678,
	"./emoji-box.svg": 679,
	"./emoji-camera.svg": 680,
	"./emoji-capsule.svg": 681,
	"./emoji-chat.svg": 682,
	"./emoji-done.svg": 683,
	"./emoji-facebook.svg": 684,
	"./emoji-france.svg": 685,
	"./emoji-grec.svg": 686,
	"./emoji-instagram.svg": 687,
	"./emoji-lampe.svg": 688,
	"./emoji-laptop.svg": 689,
	"./emoji-linkedin.svg": 690,
	"./emoji-maroc.svg": 691,
	"./emoji-messagerie.svg": 692,
	"./emoji-money.svg": 693,
	"./emoji-money2.svg": 694,
	"./emoji-pen.svg": 695,
	"./emoji-point.svg": 696,
	"./emoji-smile.svg": 697,
	"./emoji-smileSick.svg": 698,
	"./emoji-stats.svg": 699,
	"./emoji-tick.svg": 700,
	"./emoji-write.svg": 701
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 677;